/**
 * Copyright 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { When } from "react-if";
import { Button } from "@nordcloud/gnui";
import { useDisclosure } from "~/hooks";
import { DeleteMappingRule as DeleteMappingRuleModal } from "./DeleteMappingRule/DeleteMappingRule";

type Props = {
  mappingRuleId: string;
  mappingRuleName: string;
  onSuccess?: () => void;
};

export function DeleteMappingRule({
  mappingRuleId,
  mappingRuleName,
  onSuccess,
}: Props) {
  const {
    isOpen: isDeleteModalOpen,
    close: closeDeleteModal,
    open: openDeleteModal,
  } = useDisclosure(false);

  return (
    <>
      <Button
        size="md"
        severity="low"
        aria-label="delete mapping rule"
        icon="trash"
        onClick={openDeleteModal}
      />
      <When condition={isDeleteModalOpen}>
        <DeleteMappingRuleModal
          id={mappingRuleId}
          tagName={mappingRuleName}
          isDeleteModalOpen={isDeleteModalOpen}
          close={closeDeleteModal}
          onSuccess={onSuccess}
        />
      </When>
    </>
  );
}
